export default defineNuxtPlugin((nuxtApp) => {
  const router = nuxtApp.$router
// console.log('[broken-link-tracker] LOADED', window.location.href)

  // ساخت مسیر DOM برای پیدا کردن موقعیت المنت در ساختار صفحه
  const getDomPath = (el: Element, maxDepth = 5): string => {
    const parts: string[] = []
    let current: Element | null = el
    let depth = 0

    while (current && depth < maxDepth) {
      let selector = current.tagName.toLowerCase()

      if (current.id) {
        selector += `#${current.id}`
      } else if (current.className && typeof current.className === 'string') {
        const classes = current.className.trim().split(/\s+/).filter(Boolean).slice(0, 3)
        if (classes.length) {
          selector += '.' + classes.map((c) => CSS.escape(c)).join('.')
        }
      }

      const parent: Element | null = current.parentElement
      if (parent) {
        const siblings = Array.from(parent.children).filter(
          (c) => c.tagName === current!.tagName
        )
        if (siblings.length > 1) {
          selector += `:nth-of-type(${siblings.indexOf(current!) + 1})`
        }
      }

      parts.unshift(selector)
      current = current.parentElement
      depth++
    }

    return parts.join(' > ')
  }

  // استخراج تمام datasetها (مثل data-product-id)
  const getDataAttributes = (el: Element): Record<string, string> => {
    const data: Record<string, string> = {}
    const htmlEl = el as HTMLElement
    if (htmlEl && htmlEl.dataset) {
      for (const key of Object.keys(htmlEl.dataset)) {
        data[key] = String(htmlEl.dataset[key] || '').slice(0, 200)
      }
    }
    return data
  }

  const handleClick = (event: MouseEvent) => {
    // console.log('[broken-link-tracker] click captured', event.target)

    const target = event.target
    if (!(target instanceof Element)) return

    const anchor = target.closest('a[href]') as HTMLAnchorElement | null
    if (!anchor) return

    const href = anchor.getAttribute('href')
    if (!href) return

    // فیلتر کردن پروتکل‌ها و رفتارهای غیرصفحه‌ای
    if (
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:')
    ) {
      return
    }

    // فیلتر کردن کلیک‌های ترکیبی و تب‌های جدید
    if (
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey ||
      anchor.hasAttribute('download') ||
      anchor.target === '_blank'
    ) {
      return
    }

    let url: URL
    try {
      url = new URL(href, window.location.origin)
    } catch {
      return
    }

    if (url.origin !== window.location.origin) return

    const destination = url.pathname + url.search + url.hash
    const resolved = router.resolve(destination)

    // اگر مسیر با روتر مچ شد، خطا نیست
    if (resolved.matched.length > 0) return

    const visibleText =
      anchor.textContent?.trim() ||
      (anchor.querySelector('img') as HTMLImageElement)?.alt ||
      anchor.getAttribute('aria-label') ||
      anchor.title ||
      null

    const report = {
      type: 'broken-link-click',
      brokenUrl: destination,
      clickedFrom: window.location.pathname + window.location.search,
      linkText: visibleText ? visibleText.slice(0, 200) : null,
      domPath: getDomPath(anchor),
      dataAttributes: getDataAttributes(anchor),
      innerHTMLPreview: anchor.innerHTML.slice(0, 300),
      timestamp: new Date().toISOString(),
    }

    console.log('[broken-link] detected:', report)

    fetch('/market/api/log-broken-link', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(report),
      keepalive: true,
    }).catch(() => {})
  }

  document.addEventListener('click', handleClick, true)
})
